import { FC } from 'react';
import { TriangleAlertIcon } from 'lucide-react';

import { Button } from '@new/common/ui/Button/Button';

interface AppErrorFallbackProps {
  resetError: () => void;
  title?: string;
  description?: string;
}

export const AppErrorFallback: FC<AppErrorFallbackProps> = ({
  resetError,
  title = 'Something went wrong',
  description = 'An unexpected error occurred and has been reported. You can try again, or refresh the page if the problem persists.',
}) => {
  return (
    <div
      role="alert"
      className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center"
    >
      <TriangleAlertIcon className="h-10 w-10 text-destructive opacity-80" aria-hidden />
      <h1 className="text-xl font-semibold">{title}</h1>
      <p className="max-w-md text-muted-foreground">{description}</p>
      <Button variant="primary" onClick={resetError}>
        Try again
      </Button>
    </div>
  );
};
